<template>
  <div class="editor">
    <div id="e">
    </div>
  </div>
</template>

<script>
import E from 'wangeditor'
import oss from '@/utils/ali-oss'
export default {
  name: 'editor',
  data() {
    return {
      content: '',
      editor: null,
      info_: null,
    }
  },
  model: {
    prop: 'desc',
    event: 'change',
  },
  watch: {
    isClear(val) {
      // console.log(val)
      if (val) {
        this.editor.txt.clear()
        // this.info_=null
      }
    },
    desc(value) {
      //console.log("desc",value)
      if (value != this.editor.txt.html()) {
        this.editor.txt.html(this.desc)
      }
    },
  },
  props: {
    desc: {
      type: String,
      default: '',
    },
    //业务中我们经常会有添加操作和编辑操作，添加操作时，我们需清除上一操作留下的缓存
    isClear: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    initE() {
      this.editor = new E('#e')
      this.editor.config.onchangeTimeout = 1000 // 单位 ms
      this.editor.config.customUploadImg = (resultFiles, insertImgFn) => {
        resultFiles.forEach((item) => {
          oss.ossUploadFile({ file: item }, 1).then(res => {
            //     // 上传图片，返回结果，将图片插入到编辑器中
            insertImgFn(res)
          })
        })
      }
      this.editor.config.customUploadVideo = function (
        resultFiles,
        insertVideoFn
      ) {
        resultFiles.forEach((item) => {
          oss.ossUploadFile({ file: item }, 1).then(res => {
            insertVideoFn(res);
          })
        })
      }
      this.editor.config.onchange = (html) => {
        this.info_ = html // 绑定当前逐渐地值
        this.$emit('change', this.info_) // 将内容同步到父组件中
      }
      //去除富文本中粘贴word样式问题
      //   this.editor.config.pasteFilterStyle = false //手动关闭掉粘贴样式的过滤
      this.editor.config.pasteTextHandle = function (content) {
        // content 即粘贴过来的内容（html 或 纯文本），可进行自定义处理然后返回
        if (content == '' && !content) return ''
        var str = content
        str = str.replace(/<h1\/?[^>]*>/g, '')
        // str = str.replace(/<b></b>\/?[^>]*>/g, '')
        str = str.replace(/<h2\/?[^>]*>/g, '')
        str = str.replace(/<h3\/?[^>]*>/g, '')
        str = str.replace(/<h4\/?[^>]*>/g, '')
        str = str.replace(/<a\/?[^>]*>/g, '')
        str = str.replace(/<table\/?[^>]*>/g, '<table style="margin:0 auto"')
        // str = str.replace(/<xml>[\s\S]*?<\/xml>/gi, '')
        // str = str.replace(/<style>[\s\S]*?<\/style>/gi, '')
        // str = str.replace(/<\/?[^>]*>/g, '')
        // str = str.replace(/[ | ]*\n/g, '<p>')
        // str = str.replace(/&nbsp;/gi, '')
        return str
      }
      this.editor.config.menus = [
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        'list', // 列表
        'justify', // 对齐方式
        'quote', // 引用
        'emoticon', // 表情
        'image', // 插入图片
        'video',
        'table', // 表格
        'code', // 插入代码
        'undo', // 撤销
        'redo', // 重复
      ]
      this.editor.create()
      // this.editor.txt.html(this.desc)
      //  this.editor.txt.html(this.desc)
    },
  },
  mounted() {
    this.initE()
  },
  destroyed() { },
}
</script>

<style>
video::-internal-media-controls-download-button {
  display: none !important;
}

video::-webkit-media-controls-enclosure {
  overflow: hidden !important;
}

video::-webkit-media-controls-panel {
  width: calc(100% + 50px) !important;
}
</style>
